import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect, useRef, useState } from "react";
import "./LineDrow.css";


const LineDrow = ({ data }) => {
  const svgRef = useRef(null);
  const [isInView, setIsInView] = useState(false);
  const [showCircle, setShowCircle] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
        }
      },
      { threshold: 0.5 }
    );

    if (svgRef.current) {
      observer.observe(svgRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (isInView) {
      const path = document.getElementById("myPath");
      if (path) {
        const pathLength = path.getTotalLength();
        path.style.strokeDasharray = pathLength;
        path.style.strokeDashoffset = pathLength;
        path.getBoundingClientRect(); // Force reflow
        path.style.transition = "stroke-dashoffset 2s ease-in-out";
        path.style.strokeDashoffset = "0";

        // Show the circle after the line animation completes
        setTimeout(() => {
          setShowCircle(true);
        }, 2000);
      }
    }
  }, [isInView]);

  return (
    <div className="sectionBg">
      <div className="row col-11 m-auto">
        <div className="col-12 row">
          <div className="col-md-5 col-12 text-start mt-4">
            <p data-aos="fade-up">{data.title}</p>
            {/* <p data-aos="fade-up" className="fs-2">Comprehensive</p>
            <p data-aos="fade-up" className="org fs-2 fw-bold">
              Wealth & Investment Management Solutions
            </p> */}
            <p data-aos="fade-up" className="fs-3 org fw-semibold ">
              {data.description}
            </p>
          </div>
        </div>
        <div className="row col-12">
          <div className="col-md-4 col-1"></div>
          <div className="col-md-2" ref={svgRef}>
            <svg
              id="mySvg"
              xmlns="http://www.w3.org/2000/svg"
              width="224"
              height="164"
              viewBox="0 0 224 164"
              fill="none"
            >
              {/* Line Animation */}
              <path
                id="myPath"
                d="M2 2H199C200.657 2 202 3.34315 202 5V133"
                stroke="#28282B"
                strokeOpacity="0.5"
                strokeWidth="3"
                strokeLinecap="round"
                style={{
                  strokeDasharray: "none",
                  strokeDashoffset: "none",
                }}
              />

              {/* Circle Animation */}
              {showCircle && (
                <>
                  <circle
                    cx="202.713"
                    cy="142.221"
                    r="21.2913"
                    fill="#F47024"
                    fillOpacity="0.2"
                    className="blinking-circle"
                  />
                  <circle
                    cx="203.379"
                    cy="141.556"
                    r="9.98032"
                    fill="#F47024"
                    className="blinking-circle"
                  />
                </>
              )}
            </svg>
          </div>
        </div>

        <div className="row col-12 justify-content-end">
          <div className="col-md-6 col-12  text-md-start text-end fs-5">
            {data.items.map((item, index) => (
              <p
                key={index}
                data-aos="fade-up"
                className="tJustify"
                style={{ transitionDelay: `${index * 0.3}s` }}
              >
                <span className="fw-bold">{item.key}</span> — {item.text}
              </p>
            ))}
            <br />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LineDrow;
